import * as React from 'react'
import { Body, ColumnFlexBox, RowFlexBox } from '../../components/templates/Wrappers';
import { IsTablet, useWindowSize } from '../../globals/UIHooks';
import { TabletMax } from '../../globals/UIValues';
import { getPublicProjectData } from '../../globals/ApiHooks';
import colors from '../../globals/colors';
import { lang } from '../../globals/Translations';
import { PublicDataBox } from '../../shared/UI';
import { ToolTip } from '../../components/atoms/Inputs';



export const PublicProjectOverview: React.FC = () => {
  const [loading, setLoading] = React.useState(false)
  const [projectCITTableData, setProjectCITTableData] = React.useState<string[][]>()

  const [dataBoxes, setDataBoxes] = React.useState<PublicDataBox[]>([])
  const tablet = IsTablet(useWindowSize().width)

  const getData = async () => {
    setLoading(true)
    const result = await getPublicProjectData()
    if (result) {
      setProjectCITTableData(result.projectCentralInvestorInformation)
      setDataBoxes(result.projectDataBoxes)
    }
    setLoading(false)
  }

  React.useEffect(() => {
    getData()
  }, [])

  return (
    <Body loading={loading}>
      <div style={{ width: tablet ? "100%" : TabletMax, margin: 'auto', marginTop: 40 }}>
        <div className="cardnohover padding">
          <img
            width="250px"
            src="https://prod-attachments-bucket-fb-2-0.s3.eu-west-1.amazonaws.com/59c23268-89c9-4132-9a6c-c97a7aa61eff.png"
            alt="Fundbricks logo" />

          <ColumnFlexBox>
            <RowFlexBox style={{ flexWrap: 'wrap' }}>
              {dataBoxes.map((box, index) => (
                <ColumnFlexBox key={index} style={{ minWidth: 140, padding: 12, borderRadius: 12, backgroundColor: colors.primaryOpacity, marginRight: 12, marginBottom: 12 }}>
                  <RowFlexBox><span>{box.label}</span> {box.tooltip && <ToolTip content={box.tooltip} />}</RowFlexBox>
                  <b>{box.value}</b>
                </ColumnFlexBox>
              ))}
            </RowFlexBox>
            {projectCITTableData && projectCITTableData.length > 0 && <h3>Central investorinformation</h3>}
            <table style={{ fontSize: 12 }}>
              <thead>
                <tr style={{ backgroundColor: colors.dark, color: colors.lightest }}>
                  {projectCITTableData && projectCITTableData.length > 0 && projectCITTableData[0].map((cell, i) => (
                    <th style={{ textAlign: i === 0 ? 'left' : 'right', paddingLeft: 6, paddingRight: 6 }} key={i} >{cell}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {projectCITTableData && projectCITTableData.length > 0 && projectCITTableData.slice(1, projectCITTableData.length).map((rows, ri) => (
                  <tr style={{ backgroundColor: ri % 2 === 0 ? colors.primaryOpacity : colors.opacityText }}>{rows.map((cell, i) => (
                    <td style={{ textAlign: i === 0 ? 'left' : 'right', paddingLeft: 6, paddingRight: 6 }} key={i}>{cell.includes("http") ? <a target='_blank' href={cell}>Link</a> : cell}</td>
                  ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </ColumnFlexBox>
        </div>
      </div>
    </Body>
  )
};
